/* src/app/private/components/google-config/google-config-details/google-config-details.component.scss */
/*# sourceMappingURL=google-config-details.component.css.map */
